import { Plugin } from "prosemirror-state";

export const figureDeletionDetection = new Plugin({
  appendTransaction: (transactions, oldState, newState) => {
    if(!transactions.some(tr => tr.docChanged)) {
      return;
    }

    const { tr } = newState,
      emptyNodes = [];

    newState.doc.descendants((node, pos) => {
      if(node.type.name === "figure" && node.content.content[0].attrs.src === null) {
        emptyNodes.push({ node, pos });
      }
    });

    if(emptyNodes.length > 0) {
      emptyNodes.forEach(({ node, pos }) => {
        tr.delete(pos, pos + node.nodeSize);
      });

      return tr;
    }

    return null;
  }
})